// extracted by mini-css-extract-plugin
export default {"tag":"tag-EntGbX","editable":"editable-IstIhe","content":"content-ggN0Nw","plain":"plain-XlsJ1C","delete":"delete-XRbJmO","is-focused":"is-focused-Zp_otH"};